import { Link } from 'react-router-dom';
import { Typography } from './ui';

const Footer = () => {
  return (
    <footer
      className="border-t mt-auto"
      style={{
        backgroundColor: 'var(--bg-tertiary)',
        borderColor: 'var(--border)',
      }}
    >
      <div className="mx-auto px-4 sm:px-6 lg:px-8 py-8 sm:py-12">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6 sm:gap-8 mb-6 sm:mb-8">
          {/* Company Info */}
          <div className="space-y-4 sm:col-span-2 lg:col-span-1">
            <Typography variant="h4" style={{ color: 'var(--accent)' }}>
              SudoSys
            </Typography>
            <Typography
              variant="body2"
              color="secondary"
              className="leading-relaxed"
            >
              From Intuition to Execution
            </Typography>
            <div className="flex gap-4">
              {/* <a
                href="https://linkedin.com/company/sudosys"
                target="_blank"
                rel="noopener noreferrer"
                className="text-2xl hover:scale-110 transition-transform touch-target"
                style={{ color: 'var(--text-secondary)' }}
                aria-label="LinkedIn"
              >
                💼
              </a> */}
              {/* <a
                href="https://twitter.com/sudosys"
                target="_blank"
                rel="noopener noreferrer"
                className="text-2xl hover:scale-110 transition-transform touch-target"
                style={{ color: 'var(--text-secondary)' }}
                aria-label="Twitter"
              >
                🐦
              </a> */}
              <a
                href="https://github.com/sudosys-org"
                target="_blank"
                rel="noopener noreferrer"
                className="text-2xl hover:scale-110 transition-transform touch-target"
                style={{ color: 'var(--text-secondary)' }}
                aria-label="GitHub"
              >
                💻
              </a>
            </div>
          </div>

          {/* Services */}
          <div>
            <Typography variant="h5" className="mb-3 sm:mb-4">
              Services
            </Typography>
            <div className="space-y-2">
              <Link
                to="/services"
                className="block py-1 text-sm sm:text-base transition-colors hover:opacity-80"
                style={{ color: 'var(--text-secondary)' }}
              >
                Custom Software Development
              </Link>
              <Link
                to="/services"
                className="block py-1 text-sm sm:text-base transition-colors hover:opacity-80"
                style={{ color: 'var(--text-secondary)' }}
              >
                AI & Machine Learning
              </Link>
              <Link
                to="/services"
                className="block py-1 text-sm sm:text-base transition-colors hover:opacity-80"
                style={{ color: 'var(--text-secondary)' }}
              >
                DevOps & Automation
              </Link>
            </div>
          </div>

          {/* Company */}
          <div>
            <Typography variant="h5" className="mb-3 sm:mb-4">
              Company
            </Typography>
            <div className="space-y-2">
              <Link
                to="/about"
                className="block py-1 text-sm sm:text-base transition-colors hover:opacity-80"
                style={{ color: 'var(--text-secondary)' }}
              >
                About Us
              </Link>
              {/* <Link
                to="/portfolio"
                className="block py-1 text-sm sm:text-base transition-colors hover:opacity-80"
                style={{ color: 'var(--text-secondary)' }}
              >
                Portfolio
              </Link> */}
              {/* <Link
                to="/blog"
                className="block py-1 text-sm sm:text-base transition-colors hover:opacity-80"
                style={{ color: 'var(--text-secondary)' }}
              >
                Blog
              </Link> */}
              <Link
                to="/contact"
                className="block py-1 text-sm sm:text-base transition-colors hover:opacity-80"
                style={{ color: 'var(--text-secondary)' }}
              >
                Contact
              </Link>
            </div>
          </div>

          {/* Contact Info */}
          <div>
            <Typography variant="h5" className="mb-3 sm:mb-4">
              Contact
            </Typography>
            <div className="space-y-1">
              <div>
                <a
                  href="mailto:hello@sudosys.org"
                  className="flex items-center gap-2 transition-colors hover:opacity-80 py-1"
                  style={{ color: 'var(--text-secondary)' }}
                >
                  <span className="text-lg">📧</span>
                  <Typography
                    variant="body2"
                    color="secondary"
                    className="text-sm sm:text-base"
                  >
                    hello@sudosys.org
                  </Typography>
                </a>
              </div>
              <div>
                <a
                  href="tel:+918756523281"
                  className="flex items-center gap-2 transition-colors hover:opacity-80 py-1"
                  style={{ color: 'var(--text-secondary)' }}
                >
                  <span className="text-lg">📞</span>
                  <Typography
                    variant="body2"
                    color="secondary"
                    className="text-sm sm:text-base"
                  >
                    +91-8756523281
                  </Typography>
                </a>
              </div>
              <div>
                <a
                  href="https://sudosys.org"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="flex items-center gap-2 transition-colors hover:opacity-80 py-1"
                  style={{ color: 'var(--text-secondary)' }}
                >
                  <span className="text-lg">🌐</span>
                  <Typography
                    variant="body2"
                    color="secondary"
                    className="text-sm sm:text-base"
                  >
                    sudosys.org
                  </Typography>
                </a>
              </div>
              <div>
                <a
                  href="https://www.google.com/maps/search/?api=1&query=SudoSys+Private+Limited,Office no:GF064, B-128, First Floor, Sector-2 Gautam Buddha Nagar, Noida,
Uttar Pradesh 201301,+India"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="flex items-center gap-2 transition-colors hover:opacity-80 py-1"
                  style={{ color: 'var(--text-secondary)' }}
                  title="View SudoSys office location on Google Maps"
                >
                  <span className="text-lg">📍</span>
                  <Typography
                    variant="body2"
                    color="secondary"
                    className="text-sm sm:text-base"
                  >
                    Office no:GF064, B-128, First Floor, Sector-2 Gautam Buddha Nagar, Noida, Uttar Pradesh 201301, India
                  </Typography>
                </a>
              </div>
            </div>
          </div>
        </div>

        {/* Newsletter Section */}
        {/* <div
          className="py-8 border-t border-b"
          style={{ borderColor: 'var(--border)' }}
        >
          <NewsletterFooter />
        </div> */}

        {/* Bottom Bar */}
        <div
          className="pt-6 sm:pt-8 border-t flex flex-col sm:flex-row justify-between items-center gap-4 text-center sm:text-left"
          style={{ borderColor: 'var(--border)' }}
        >
          <Typography
            variant="body2"
            color="secondary"
            className="text-xs sm:text-sm"
          >
            &copy; 2025 SudoSys. All rights reserved.
          </Typography>
          <div className="flex flex-col sm:flex-row gap-4 sm:gap-6">
            <Link
              to="/privacy"
              className="text-xs sm:text-sm py-2 sm:py-0 transition-colors hover:opacity-80"
              style={{ color: 'var(--text-secondary)' }}
            >
              Privacy Policy
            </Link>
            <Link
              to="/terms"
              className="text-xs sm:text-sm py-2 sm:py-0 transition-colors hover:opacity-80"
              style={{ color: 'var(--text-secondary)' }}
            >
              Terms of Service
            </Link>
            <Link
              to="/refund"
              className="text-xs sm:text-sm py-2 sm:py-0 transition-colors hover:opacity-80"
              style={{ color: 'var(--text-secondary)' }}
            >
              Refund Policy
            </Link>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
